import './index.scss';
import React, { PropTypes } from 'react';
import _ from 'underscore';
import ourPropTypes from '../../../js/ourPropTypes';

const StepsNavigation = React.createClass({
    render: function () {
        return (
            <div className="flow-navigation-container">
                <ul className="navigation">
                    {_.map(this.props.steps, (step, i) => {
                        const item = <li key={step.name} className={step.isActive ? 'active' : ''}><a>{step.name}</a></li>;
                        return (i + 1) === this.props.steps.length
                            ? item
                            : ([item, <li key={`${step.name}-arrow`} className="arrow"><a>→</a></li>]);
                    })}
                </ul>
            </div>
        );
    }
});

StepsNavigation.propTypes = {
    steps: ourPropTypes.idNameArray.isRequired
};

export default StepsNavigation;


// WEBPACK FOOTER //
// ./src/components/common/StepsNavigation/index.jsx